<div class="if-radio-group-wrapper">
  @for (option of options(); track option.value) {
    <label class="if-radio-label">
      <input
        type="radio"
        class="if-radio"
        [name]="name()"
        [value]="option.value"
        [checked]="internalValue === option.value"
        [disabled]="isOptionDisabled(option)"
        (change)="onRadioChange($event)"
        (blur)="onBlur()" />
      <span class="if-radio-custom"></span>
      <span class="if-radio-text">{{ option.label }}</span>
    </label>
  }
</div>
